import React from 'react';
import PropTypes from 'prop-types';
import './InfoBox.sass';
export const InfoBox = ({ children }) => {
  return <div className="info-box">{children}</div>;
};
InfoBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
